module.exports = __webpack_public_path__ + "static/media/vvns-order-tracking-mail-icon.a7359a78.svg";